import React, { useState } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import styled from "styled-components"

import HeaderBottomNavItem from "./HeaderBottomNavItem"
import { navOne, colors } from "../../styles/helpers"
import Download from "../Icons/Download"

const BottomNav = styled.nav`
  align-self: center;

  @media (min-width: 1025px) {
    margin-right: 4rem;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
`

const getData = graphql`
  {
    mainMenu: wordpressWpApiMenusMenusItems(name: { eq: "Main Menu" }) {
      items {
        wordpress_id
        title
        object_slug
        target
        type
        url
        wordpress_children {
          wordpress_id
          title
          object_slug
          url
        }
      }
    }
  }
`

const HeaderBottomNav = ({
  location,
  setAppDownload,
  handleModalState,
  isActive,
}) => {
  const data = useStaticQuery(getData)
  const menuItems = data.mainMenu.items
  return (
    <BottomNav>
      <div>
        <ul>
          {menuItems.length > 0 &&
            menuItems.map(item => (
              <HeaderBottomNavItem
                key={item.object_slug}
                item={item}
                location={location}
              />
            ))}
          {/* <LinkStyles>
            <Link to="/contact">contact</Link>
          </LinkStyles> */}
        </ul>
      </div>
    </BottomNav>
  )
}

const LinkStyles = styled.li`
  position: relative;
  margin: 0;

  a,
  button {
    ${navOne};
    display: block;
    padding: 2rem;
    border: none;
    background-color: ${props =>
      props.current || props.isActive ? colors.colorNew : "transparent"};
    color: ${colors.black};
    text-transform: uppercase;

    &:hover {
      color: ${colors.white};
      cursor: ${props => (props.current ? "default" : "pointer")};
      background-color: ${colors.colorNew};
    }

    &[aria-current="page"] {
      background-color: ${colors.colorNew};
    }
  }
`

export default HeaderBottomNav
